import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  const renderSectionTitle = (title) => (
    <div className="w-full mt-2 mb-3">
      <div className="flex items-center justify-center">
        <div className="bg-[#f27121] text-center text-white font-black uppercase w-full md:w-[550px] max-w-full px-6 md:px-14 py-1.5 md:py-2 text-[14px] md:text-[22px] leading-[24px] md:leading-[32px] clip-title">
          {title}
        </div>
      </div>
      <div className="w-full h-px bg-[#f27121] mt-0.5" />
    </div>
  );

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />

        <div
          className="max-w-[1000px] mx-auto mt-2 mb-4 w-full relative bg-white/95 border-2 border-solid shadow shadow-primary rounded-2xl p-4 md:p-6"
          style={{
            background: '#FFFFFF80',
            borderColor: '#f27121',
            borderRadius: '1.5rem'
          }}
        >
          <div className="flex flex-col lg:flex-row justify-center items-center gap-4 md:gap-6">
            <div className="md:max-w-[250px] max-w-[220px] shrink-0">
              <img
                src="/assets/images/header/left-ketqua.png"
                alt=""
                className="w-full h-full object-contain"
              />
            </div>

            <div className="w-full mx-auto lg:mt-0 px-1 mt-1">
              <table className="w-full text-center" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                <thead>
                  <tr>
                    <th className="bg-[#f27121] text-white text-[16px] sm:text-[18px] md:text-[20px] font-semibold py-2 px-2 rounded-tl-[9px]">
                      Cấp độ VIP
                    </th>
                    <th className="bg-[#f27121] text-white text-[16px] sm:text-[18px] md:text-[20px] font-semibold py-2 px-2 rounded-tr-[9px]">
                      Tiền Thưởng
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-transparent">
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold  py-3 px-2">VIP 0</td>
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">29</td>
                  </tr>
                  <tr className="bg-[#F6F6F6]">
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold  py-3 px-2">VIP 1 - VIP 5</td>
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">99</td>
                  </tr>
                  <tr className="bg-transparent">
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold py-3 px-2">VIP 6 - VIP 10</td>
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">299</td>
                  </tr>
                  <tr className="bg-[#F6F6F6]">
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold py-3 px-2">VIP 11 - VIP 20</td>
                    <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">999</td>
                  </tr>
                 
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-full h-px bg-[#d9d9d9] my-4" />
          {renderSectionTitle('Kết quả trận đấu')}
          <MatchResult embedded />
          <style>
            {`
              .clip-title {
                clip-path: polygon(6% 0, 94% 0, 100% 100%, 0 100%);
              }
            `}
          </style>
        </div>
      </div>
    </div>
  );
};

export default PrizeStructure;
